import { LayerDefinition } from './types';

export const opticsDewRiskDefinition: LayerDefinition = {
  id: 'optics_dew_risk',
  name: 'Optics Dew Risk',
  category: 'forecast',
  categoryLabel: 'Specialized Forecast Index',
  icon: '💧',
  description: 'Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'icon13'],
  outputModels: ['blend & hrrr .pmtiles'],
  config: {
    defaultModel: 'blend'
  }
};

export default opticsDewRiskDefinition;
